import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton, IconInfo } from 'src/components/ui'

import styles from './HistoryMissing.module.scss'

const HistoryMissing = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <>
      <div className={styles.wrapper}>
        <IconInfo color='violet' name='historyMissing' className={styles.icon} />
        <h1>{t('history_participations.missing.title')}</h1>
        <p>{t('history_participations.missing.description')}</p>
      </div>

      <CustomButton
        onClick={() => navigate('/bottles?mode=my')}
        variant='contained'
        color='violet'
        className={styles.btn}
      >
        {t('history_participations.missing.show_banks')}
      </CustomButton>
    </>
  )
}

export default HistoryMissing
